import { SnackbarErrorMessage } from '@ui-components/components/customized-snackbar/snackbar-message.enum';

export interface SummarySelectFilterConfig {
  id: number;
  label: string;
}

export const Unassigned = 'Unassigned';
export const System = 'System';

export type SummaryConfigType = {
  key: string;
  queries?: SummaryQueryConfig[];
  configColumns?: string[];
  columns?: {
    [key: string]: SummaryConfigColumnKey;
  };
};

export type reportViewConfig = {
  id: number;
  label: string;
  group?: number;
  defaultSortColumn?: string;
};

export type SummaryQueryConfig = {
  queryId: number;
  configColumns: string[];
  columnGroup?: {
    label: string;
    from: string;
    to: string;
  };
  columns: {
    [key: string]: SummaryConfigColumnKey;
  };
};

export type SummaryConfigColumnKey = {
  key: string;
  displayKey: string;
  tooltip?: string;
  isSumRequired: boolean;
  sumKeys: string[];
  diffKeys?: string[][];
  isBracketsRequired: boolean;
  bracketsSumKeys: string[];
};

export const baseColumnConfig = {
  isSumRequired: false,
  sumKeys: [],
  diffKeys: [],
  isBracketsRequired: false,
  bracketsSumKeys: [],
};

export namespace SummaryPeriodListConstants {
  export enum TimeFrame {
    Week = 1,
    Month,
    Month_3,
    Month_6,
    Year,
    AllTime,
    Custom,
    ThisWeek,
    NextTwoWeeks,
    ThisMonth,
    ThisQuarter,
    ThisYear,
  }

  export enum IncludeArchived {
    Yes = 1,
    No = 0,
  }

  export const timeFrames = [
    { value: TimeFrame.Week, label: 'past 7 days' },
    { value: TimeFrame.Month, label: 'past 30 days' },
    { value: TimeFrame.Month_3, label: 'past 3 months' },
    { value: TimeFrame.Month_6, label: 'past 6 months' },
    { value: TimeFrame.Year, label: 'past year' },
    { value: TimeFrame.ThisWeek, label: 'this week' },
    { value: TimeFrame.NextTwoWeeks, label: 'next two weeks' },
    { value: TimeFrame.ThisMonth, label: 'this month' },
    { value: TimeFrame.ThisQuarter, label: 'this quarter' },
    { value: TimeFrame.ThisYear, label: 'this year' },
    { value: TimeFrame.AllTime, label: 'all time' },
    { value: TimeFrame.Custom, label: 'custom' },
  ];

  export const includeArchivedList = [
    { value: IncludeArchived.Yes, label: 'Yes' },
    { value: IncludeArchived.No, label: 'No' },
  ];
}

export const FILTER_PERIOD_RECORD = {
  sevenDays: 'past 7 days',
  thirtyDays: 'past 30 days',
  sixtyDays: 'past 60 days',
  threeMonths: 'past 3 months',
  thisWeek: 'this week',
  thisMonth: 'this month',
  thisQuarter: 'this quarter',
  thisYear: 'this year',
  sixMonths: 'past 6 months',
  year: 'past year',
  nextTwoWeeks: 'next two weeks',
  nextThirtyDays: 'next 30 days',
  nextSixtyDays: 'next 60 days',
  nextSixMonths: 'next 6 months',
  allTime: 'all time',
  custom: 'custom',
};

export enum SUMMARY_ACTION__ENUM {
  DRILL_DOWN = 1,
  OPEN_IN_NEW_TAB = 2,
}

export const SELECT_FILTER_ACTION_CONFIG: SummarySelectFilterConfig[] = [
  {
    id: SUMMARY_ACTION__ENUM.DRILL_DOWN,
    label: 'Drill Down',
  },
  {
    id: SUMMARY_ACTION__ENUM.OPEN_IN_NEW_TAB,
    label: 'Open in a New Tab',
  },
];

export const SELECT_FILTER_PERIOD_CONFIG: SummarySelectFilterConfig[] = [
  {
    id: SummaryPeriodListConstants.TimeFrame.Week,
    label: FILTER_PERIOD_RECORD.sevenDays,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.Month,
    label: FILTER_PERIOD_RECORD.thirtyDays,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.Month_3,
    label: FILTER_PERIOD_RECORD.threeMonths,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.Month_6,
    label: FILTER_PERIOD_RECORD.sixMonths,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.Year,
    label: FILTER_PERIOD_RECORD.year,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.ThisWeek,
    label: FILTER_PERIOD_RECORD.thisWeek,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.NextTwoWeeks,
    label: FILTER_PERIOD_RECORD.nextTwoWeeks,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.ThisMonth,
    label: FILTER_PERIOD_RECORD.thisMonth,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.ThisQuarter,
    label: FILTER_PERIOD_RECORD.thisQuarter,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.ThisYear,
    label: FILTER_PERIOD_RECORD.thisYear,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.AllTime,
    label: FILTER_PERIOD_RECORD.allTime,
  },
  {
    id: SummaryPeriodListConstants.TimeFrame.Custom,
    label: FILTER_PERIOD_RECORD.custom,
  },
];

export const SUMMARY_ERROR = {
  errorWrong: SnackbarErrorMessage.SomethingWentWrong,
  errorNoData: 'No data to display.',
};
